const CheckIcon = () => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <circle fill="none" cx="18" cy="18" r="18"/>
            <path d="m15.7 24.025-5.7-5.7 1.425-1.425 4.275 4.275L24.875 12l1.425 1.425z" fill="currentColor" fillRule="nonzero"/>
        </g>
    </svg>
  )
}

export default CheckIcon
